import cx from "classnames";
import { ReactNode } from "react";

type Props = {
  title: ReactNode;
  children: ReactNode;
  className?: string;
  childrenContainerClassName?: string;
};

export function PoolsDetailsCard({ title, children, className, childrenContainerClassName }: Props) {
  return (
    <div className={cx("flex flex-col rounded-8 bg-gray-darker p-[10.5px] sm:p-16", className)}>
      <div className="text-body-large font-medium text-white">{title}</div>
      <div className={cx(childrenContainerClassName)}>{children}</div>
    </div>
  );
}
